export const LIST_INFO_AUDIT = 'LIST_INFO_AUDIT'
export const LIST_INFO_CC = 'LIST_INFO_CC'
export const LIST_INFO_HISTORY = 'LIST_INFO_HISTORY'
export const LIST_INFO_SEAL = 'LIST_INFO_SEAL'
export const LIST_INFO_FILE = 'LIST_INFO_FILE'
export const SET_CONTRACT_DETAIL = 'FOUND_CONTRACT_DETAIL'
export const SET_SEALOUT_DETAIL = 'FOUND_SEALOUT_DETAIL'
export const RESET_CONTRACT_DETAIL = 'RESET_CONTRACT_DETAIL'
export const RESET_SEALOUT_DETAIL = 'RESET_SEALOUT_DETAIL'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js